// extracted by mini-css-extract-plugin
export var card = "_mm-1";
export var summary = "_mm-0";